export default __webpack_public_path__ + "static/media/Screenshot 2025-07-17 at 18-1753122593434.faf2020e.png";